<template>
    <div>
        <!-- <h1 class="display-heading">{{title}}<i v-if="isFamily" class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" :title="getTitleLabel()"></i></h1> -->
        <h1 class="display-heading">{{title}}</h1>
        <p>You may upload your medical reports here so that doctors could diagnose you better. </p>

        <div class="card mb-3">
            <div class="card-header">Upload Medical Report</div>
            <div class="card-body">
                <form @submit.prevent="validateReportForm">
                    <div>
                        <div v-if="isFamily" class="form-group row">
                            <label class="col-sm-3 col-xl-2 col-form-label">Patient Name</label>
                            <div class="col-sm-9 col-xl-10">
                                <div>
                                    <select placeholder="Patient" name="patient" v-model="uploadForm.dependentId"
                                        data-vv-as="patient" data-vv-validate-on="blur"
                                        v-validate="'required'" :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('patient')
                                    }">
                                        <option :value="null" disabled hidden>Please Select...</option>
                                        <option v-for="(dependent, index) in dependentList" :key="index"
                                            :value="dependent.userId">
                                            {{dependent.fullName}}
                                        </option>
                                    </select>
                                    <div v-show="validationErrors.has('patient')" class="invalid-feedback">
                                        {{ validationErrors.first('patient') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-xl-2 col-form-label">Report Type</label>
                            <div class="col-sm-9 col-xl-10">
                                <div>
                                    <select name="reportTypeSelect" data-vv-validate-on="blur" data-vv-as="report type"
                                        v-validate="'excluded:default'" :class="['form-control', 'mt-2', {'is-invalid':  validationErrors.has('reportTypeSelect')}]"
                                        v-model="selectedReportType">
                                        <option v-for="(report, key) in reportTypes" :key="key" :value="report.value">
                                            {{report.text}}
                                        </option>
                                    </select>
                                    <div v-show="validationErrors.has('reportTypeSelect')" class="invalid-feedback">
                                        {{ validationErrors.first('reportTypeSelect') }}
                                    </div>
                                </div>
                                <div v-show="shouldShowReportTypeInput">
                                    <input v-validate="reportTypeInputRequired" data-vv-validate-on="blur"
                                        data-vv-as="report type" name="reportType" :class="['form-control', 'mt-2', {'is-invalid': validationErrors.has('reportType')}]"
                                        type="text" placeholder="Please enter report type" v-model="uploadForm.type" />
                                    <div v-show="validationErrors.has('reportType')" class="invalid-feedback">
                                        {{ validationErrors.first('reportType') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-xl-2 col-form-label">Uploaded Files</label>
                            <div class="col-sm-9 col-xl-10">
                                <div v-if="files.length <= 0">No files uploaded.</div>
                                <div class="d-flex justify-content-between" v-for="(file, index) in files" :key="'file' + index">
                                    <span>{{ file.name }}</span>
                                    <a
                                        href="javascript: void(0);"
                                        class="delete-button"
                                        @click="deleteFile(index, index)"
                                    >
                                        <i style="color:red;" class="fas fa-trash-alt"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" v-if="stopUploading === false">
                            <label class="col-sm-3 col-xl-2 col-form-label">Report File</label>
                            <div class="col-sm-9 col-xl-10" v-if="addedFile === false">
                                <div>
                                    <input id="uploadFileInput" type="file" name="reportFile">
                                    <button type="button" @click="addFile" class="btn btn-primary btn-primary-insv ml-2">Add</button>
                                </div>
                            </div>
                            <div class="col-sm-9 col-xl-10" v-else>
                                <span>Do you have more files to add?</span>
                                <button type="button" @click="resetFile" class="btn btn-primary btn-primary-insv mx-2">Yes</button>
                                <button type="button" @click="focusNext" class="btn btn-secondary">No</button>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3 col-xl-2 col-form-label">Description</label>
                            <div class="col-sm-9 col-xl-10">
                                <textarea v-model="uploadForm.description" id="reportDescription" class="form-control" rows="3">
                                </textarea>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                <p v-show="isSubmitMessageShown" :class="{
                                    'text-danger': isSubmitMessageError,
                                    'mb-2': true
                                }">
                                    {{submitMessage}}
                                </p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                <button type="button" class="btn btn-primary btn-primary-insv" @click="uploadMedicalReport">Save
                                    and Upload Report</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div v-if="false" class="card mb-3">
            <div class="card-header">Storage</div>
            <div class="card-body">
                <div class="progress mb-3">
                    <div :class="['progress-bar', {
                        'bg-success': storageUtilization.usagePercentage<=25,
                        'bg-info': storageUtilization.usagePercentage>25 && storageUtilization.usagePercentage<=50,
                        'bg-warning': storageUtilization.usagePercentage>50 && storageUtilization.usagePercentage<=75,
                        'bg-danger': storageUtilization.usagePercentage>75
                    }]" role="progressbar" :style="`width: ${storageUtilization.usagePercentageDisplay}`" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                    </div>
                </div>
                <p>
                    {{storageUtilization.usage}} GB of {{storageUtilization.usageLimit}} GB Used
                </p>
            </div>
        </div>

        <div class="d-flex align-items-baseline">
            <div v-if="isFamily" class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Patient Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter patient name" data-vv-validate-on="blur"
                    v-model="filter.name" v-validate="''"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Upload Date:</label>
                <input style="width: 150px" ref="filterDate" type="text" name="filterDate" data-vv-as="filter upload  date" data-vv-validate-on="blur"
                    v-model="filter.date" v-validate="'date_format:DD/MM/YYYY'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterDate')
                    }" >
                <div v-show="validationErrors.has('filterDate')" class="invalid-feedback">
                    {{ validationErrors.first('filterDate') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Report Type:</label>
                <input style="width: 150px" type="text" name="filterType" data-vv-as="filter report type" data-vv-validate-on="blur"
                    v-model="filter.type" v-validate="''"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterType')
                    }">
                <div v-show="validationErrors.has('filterType')" class="invalid-feedback">
                    {{ validationErrors.first('filterType') }}
                </div>
            </div>
            <button @click="getReports" class="btn btn-primary">Search</button>
        </div>

        <div>
            <div class="d-md-none">
                <div class="card mb-3" v-if="uploadedReports.length === 0">
                    <div class="card-body">
                        {{isTableLoading ? "Loading Data": "No Data"}}
                    </div>
                </div>
                <div class="card mb-3" v-for="(report, index) in uploadedReports" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Upload Date
                            </label>
                            <div>
                                {{ report.date }}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Report Type
                            </label>
                            <div>
                                {{ report.reportType }}
                            </div>
                        </div>
                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                    <router-link class="btn btn-primary btn-primary-insv" :to="{'name': 'user-medical-report-detail' , 'params': {'id': report.reportId}}">View Report</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-md-block">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="40">
                        <col v-if="isFamily">
                        <col width="200">
                        <col>
                        <col width="250">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" v-if="isFamily">Patient Name</th>
                            <th scope="col">Upload Date</th>
                            <th scope="col">Report Type</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="uploadedReports.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(report, index) in uploadedReports" :key="index">
                            <th scope="row">{{index+1}}</th>
                            <td class="text-nowrap" v-if="isFamily">{{report.patientName}}</td>
                            <td class="text-nowrap">{{report.date}}</td>
                            <td class="text-nowrap">{{report.reportType}}</td>
                            <td class="text-nowrap">
                                <router-link :to="{'name': detailPath , 'params': {'id': report.reportId}}">View Report</router-link>
                                <!-- <a :href="`${apiPath}MedicalReport/DownloadReportById?reportId=${report.reportId}`" target="_blank">Download Report</a> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import {
    convertDateToIso8601,
    convertToUserReadableDate
} from '@/utilities';
import { apiPath } from '@/config';
import {
    medicalReportTypes
} from '@/config/dropdown';
export default {
    'name': 'UserMedicalReport',
    'watch': {
        selectedReportType (val) {
            if (val === this.reportTypes[0].value || val === this.reportTypes[this.reportTypes.length - 1].value) {
                this.uploadForm.type = '';
            } else {
                this.uploadForm.type = val;
            }
        }
    },
    'computed': {
        shouldShowReportTypeInput () {
            if (this.reportTypes.length === 0) {
                return false;
            }

            return this.selectedReportType === this.reportTypes[this.reportTypes.length - 1].value;
        },
        reportTypeInputRequired () {
            return this.shouldShowReportTypeInput ? 'required' : '';
        },
        isFamily () {
            return this.$route.name === 'family-medical-report';
        },
        title () {
            if (this.isFamily) {
                return 'Family Medical Reports';
            }
            return 'Medical Reports';
        },
        getApi () {
            if (this.isFamily) {
                return 'MedicalReport/GetFamily';
            }
            return 'MedicalReport/GetAll';
        },
        uploadApi () {
            if (this.isFamily) {
                return 'FileUpload/UploadFamilyMedicalReport';
            }
            return 'FileUpload/UploadMedicalReport';
        },
        detailPath () {
            if (this.isFamily) {
                return 'family-medical-report-detail';
            }
            return 'user-medical-report-detail';
        }
    },
    data () {
        return {
            apiPath,
            'reportTypes': [],
            'selectedReportType': '',
            'uploadedReports': [],
            // table related
            'columnsCount': 1,
            'isTableLoading': true,
            'uploadForm': {
                'dependentId': null,
                'type': null,
                'description': null
            },
            'storageUtilization': {
                'usageLimit': '0',
                'usage': '0',
                'usagePercentageDisplay': '0%',
                'usagePercentage': 0
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'files': [],
            'addedFile': false,
            'stopUploading': false,
            'dependentList': [],
            'filter': {
                'name': '',
                'date': null,
                'type': ''
            }
        };
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        // table related
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        this.reportTypes = medicalReportTypes.map((report) => ({
            'text': report,
            'value': report
        }));

        this.reportTypes.unshift({
            'text': 'Please select report type',
            'value': 'default'
        });

        this.reportTypes.push({
            'text': 'Others (please state)',
            'value': 'others'
        });

        this.selectedReportType = this.reportTypes[0].value;

        this.getReports();

        if (this.isFamily) {
            this.axios.get('UserDependent/GetDependentList').then(({ data }) => {
                if (data.data) {
                    this.dependentList = data.data.map((dependent) => ({
                        'userId': dependent.ui,
                        'fullName': dependent.fn
                    }));
                }
            });
        }

        this.getUtilization();
        this.initializeDatePickers();
    },
    'methods': {
        validateReportForm () {
            return this.$validator.validateAll();
        },
        initializeDatePickers () {
            $(this.$refs.filterDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.filterDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.filter.date = picker.startDate.format('DD/MM/YYYY');
                }
            );
        },
        uploadMedicalReport () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            this.validateReportForm().then((isValidate) => {
                if (isValidate) {
                    if (this.files.length <= 0) {
                        this.isSubmitMessageError = true;
                        this.submitMessage = 'No files uploaded!';
                        return;
                    }

                    let reportFile = document.querySelector('#uploadFileInput');
                    let formData = new FormData();
                    if (this.isFamily) {
                        formData.append('DependentUserId', this.uploadForm.dependentId);
                    }
                    for (const file of this.files) {
                        formData.append('MedicalReportFile', file);
                    }
                    formData.append('ReportType', this.uploadForm.type);
                    if (this.uploadForm.description) {
                        formData.append('ReportDescription', this.uploadForm.description);
                    }
                    this.submitMessage = 'Uploading and saving medical report...';
                    this.axios.post(this.uploadApi, formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        } }).then(() => {
                        this.submitMessage = 'Successfully uploaded medical report! Your medical report is saved and encrypted.';

                        // clear form
                        if (reportFile) {
                            reportFile.value = '';
                        }
                        this.files = [];
                        this.addedFile = false;
                        this.selectedReportType = null;
                        this.uploadForm.type = null;
                        this.uploadForm.description = null;

                        this.stopUploading = false;
                        this.getReports();
                        this.getUtilization();
                    }).catch((error) => {
                        this.isSubmitMessageError = true;
                        if (error.response.data) {
                            this.submitMessage = error.response.data.message;
                        } else {
                            this.submitMessage = 'Error saving medical report. Please try again.';
                        }
                    });
                } else {
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'You have error in the form. Please check your input(s) before submitting the form.';
                }
            });
        },
        getReports () {
            this.isTableLoading = false;
            this.axios.post(this.getApi, {
                'd': convertDateToIso8601(this.filter.date),
                'pn': this.filter.name,
                't': this.filter.type
            }).then(({ data }) => {
                this.uploadedReports = data.data.map((report) => ({
                    'patientName': report.pn,
                    'date': convertToUserReadableDate(report.ud),
                    'reportType': report.rt,
                    'reportId': report.ri
                }));
            }).catch(() => {

            });
        },
        getUtilization () {
            this.axios.get('FileUpload/GetUserMediaStorageUsage').then(({ data }) => {
                this.storageUtilization.usage = data.data.ut;
                this.storageUtilization.usageLimit = data.data.ul;
                this.storageUtilization.usagePercentageDisplay = data.data.upd;
                this.storageUtilization.usagePercentage = data.data.up;
            }).catch(() => {

            });
        },
        addFile () {
            let file = document.querySelector('#uploadFileInput');
            if (file.files[0]) {
                this.files.push(file.files[0]);
                this.addedFile = true;
            }
        },
        resetFile () {
            this.addedFile = false;
        },
        focusNext () {
            document.getElementById('reportDescription').focus();
            this.stopUploading = true;
        },
        deleteFile (index) {
            this.files.splice(index, 1);
        },
        getTitleLabel () {
            return 'Only can upload medical reports for child(ren) aged below 18.\n' +
            'Upon child(ren) attaining age 18 or above, they need to register another personal account with own user ID for migrating their previous medical reports.';
        }
    }
};

</script>

<style>

</style>
